import { NestedCheckGroup, NestedCheck } from 'src/app/components/wizards/nested-checks.dialog.component'
import { PROGRAM_NAMES } from 'globals/store/programs.data'


// do NOT change the ids of any checkbox.  Of course you can change labels.
const timelineDisplayChecks: NestedCheckGroup = {
  groupName: 'Program tab display options',
  checkboxes: [
    { label: 'Collapse by default',
      id: 'collapseByDefault'
    }, {
      label: 'Dates',
      id: 'eventDate'
    }, {
      label: '24hr clock (Military Time)',
      id: 'militaryTime'
    }, {
      label: 'Show time zone',
      id: 'showTimeZone'
    }, {
      label: 'Session description',
      id: 'sessionDescription'
    },{
      label: 'Session labels',
      id: 'sessionLabels'
    },{
      label: 'Public links',
      id: 'publicLinks'
    },{
      label: PROGRAM_NAMES.btn + ' detail',
      id: 'program',
      children: [{
        label: PROGRAM_NAMES.btn + ' nickname',
        id: 'programName'
      },{
        label: 'Venue room/location',
        id: 'location'
      },{
        label: 'Venue name',
        id: 'venue'
      },{
        label: 'Venue Address',
        id: 'address'
      },]
    }, {
      label: 'Performers',
      id: 'performers',
      children: [{
        label: 'Photo',
        id: 'photoUrl',
      },{
        label: 'Line 1',
        id: 'line1',
      },{
        label: 'Line 2',
        id: 'line2',
      },{
        label: 'Performer role',
        id: 'performerRoles',
      },{
        label: 'Performer labels',
        id: 'performerLabels',
      },{
        label: 'Social links',
        id: 'social',
      },{
        label: 'Bio',
        id: 'bio',
      },{
        label: 'Logo',
        id: 'logoUrl',
      },]
    },{
      label: 'Sponsors',
      id: 'sponsors',
      children: [{
        label: 'Logo',
        id: 'sponsorLogoUrl',
      },{
        label: 'Sponsor type',
        id: 'sponsorType',
      },{
        label: 'Sponsor labels',
        id: 'sponsorLabels',
      },{
        label: 'Social links',
        id: 'sponsorSocial',
      },{
        label: 'Description',
        id: 'sponsorDescription',
      },{
        label: 'Call to action',
        id: 'callToAction',
      },]
    }]
}


const performerProfileChecks: NestedCheckGroup = {
  groupName: 'Performers tab display options',
  hideId: 'performersTab',
  checkboxes: [{
      label: 'Photo',
      id: 'performerProfilePhotoUrl',
    },{
      label: 'Logo',
      id: 'performerProfileLogoUrl',
    },{
      label: 'Line 1',
      id: 'performerProfileLine1',
    },{
      label: 'Line 2',
      id: 'performerProfileLine2',
    },{
      label: 'Performer labels',
      id: 'performerProfileLabels',
    },{
      label: 'Social links',
      id: 'performerProfileSocial',
    },{
      label: 'Bio',
      id: 'performerProfileBio',
    },{
      label: 'Include performer\'s sessions',
      id: 'includePerformerSessions',
    },]
}

const sponsorProfileChecks: NestedCheckGroup = {
  groupName: 'Sponsors tab display options',
  hideId: 'sponsorsTab',
  checkboxes: [{
    label: 'Logo',
    id: 'sponsorProfileLogoUrl',
  },{
    label: 'Sponsor type',
    id: 'sponsorProfileType',
  },{
    label: 'Sponsor labels',
    id: 'sponsorProfileLabels',
  },{
    label: 'Social links',
    id: 'sponsorProfileSocial',
  },{
    label: 'Description',
    id: 'sponsorProfileDescription',
  },{
    label: 'Call to action',
    id: 'sponsorProfilecallToAction',
  },{
    label: 'Include sponsor\'s sessions',
    id: 'includeSponsorSessions',
  },]
} 

const exhibitorProfileChecks: NestedCheckGroup = {
  groupName: 'Exhibitors tab display options',
  hideId: 'exhibitorsTab',
  checkboxes: [{
    label: 'Logo',
    id: 'exhibitorProfileLogoUrl',
  },{
    label: 'Exhibitor stand number',
    id: 'exhibitorStandNumber',
  },{
    label: 'Room/location',
    id: 'exhibitorProgramName',
  },{
    label: 'Exhibitor labels',
    id: 'exhibitorProfileLabels',
  },{
    label: 'Social links',
    id: 'exhibitorProfileSocial',
  },{
    label: 'Description',
    id: 'exhibitorProfileDescription',
  },{
    label: 'Call to action',
    id: 'exhibitorProfilecallToAction',
  }]
} 


const CTAChecks: NestedCheckGroup = {
  groupName: 'CTA Display Options',
  checkboxes: [{
    label: 'Home tab',
    id: 'homeCTAs',
  },{
    label: 'Program tab',
    id: 'programCTAs',
  },{
    label: 'Performer tab',
    id: 'performerCTAs',
  },{
    label: 'Sponsor tab',
    id: 'sponsorCTAs',
  },{
    label: 'Exhibitor tab',
    id: 'exhibitorCTAs',
  }]
} 


const eventDisplayChecks: NestedCheckGroup = {
  groupName: 'Page display options',
  checkboxes: [{
    label: 'Event name',
    id: 'eventName'
  },{
    label: 'Page name',
    id: 'publishedName',
  },{
    label: 'Page description',
    id: 'publishedDescription',
  },{
    label: 'My timezone toggle',
    id: 'viewMyTimezoneToggle',
  },{
    label: 'Made with Joi logo',
    id: 'madeWithJoi'
  }]
}

const generalInstructions = { instructions: { title: 'General display options', text: 'Choose what information appears on the page.'} }
const tabInstructions = { instructions: { title: 'Tab display options', text: 'Choose which tabs display in your published timeline and what information displays on each tab.'} }

export const programPublishDisplayOptionsNestedFieldCheckGroups: NestedCheckGroup[] = [
  generalInstructions,
  eventDisplayChecks,
  CTAChecks,
  tabInstructions,
  {
    groupName: 'Home tab',
    tabId: 'homeTab',
    defaultTabName: 'Home',
    hintText: 'Home page',
  },
  {
    groupName: 'Program tab',
    tabId: 'programTab',
    defaultTabName: 'Program',
    hintText: 'Program, Agenda, etc.',
    children: [timelineDisplayChecks],
    radios: [{
      id: 'timeline',
      choices: [
        { id: 'default', label: 'Continuous Timeline' }, 
        { id: 'breakDays', label: 'View By Day'  }
      ]
    }],
  },{
    groupName: 'Performers tab',
    tabId: 'performersTab',
    defaultTabName: 'Performers',
    hintText: 'Performers, Speakers, etc.',
    topHint: 'Note: Performers only display when assigned to a session.',
    children: [performerProfileChecks]
  },{
    groupName: 'Sponsors tab',
    tabId: 'sponsorsTab',
    defaultTabName: 'Sponsors',
    hintText: 'Sponsors, Partners, etc.',
    children: [sponsorProfileChecks]
  },{
    groupName: 'Exhibitors tab',
    tabId: 'exhibitorsTab',
    defaultTabName: 'Exhibitors', // 
    hintText: 'Exhibitors, booths, etc.',
    topHint: 'Note: Exhibitors only display when assigned to a room/location.',
    children: [exhibitorProfileChecks]
  },
]


const appInstructions = { instructions: { title: 'General display options', text: 'Choose what information appears on the app.'} }
const appDisplayChecks: NestedCheckGroup = {
  groupName: 'App display options',
  checkboxes: [{
    label: 'Event name',
    id: 'eventName'
  },{
    label: 'App name',
    id: 'publishedName',
  },{
    label: 'App description',
    id: 'publishedDescription',
  }]
}
const appTabInstructions = { instructions: { title: 'Tab display options', text: 'Choose which tabs display in your published timeline and what information displays on each tab.'} }
export const appDisplayOptionsNestedFieldCheckGroups: NestedCheckGroup[] = [
  appInstructions,
  appDisplayChecks,
  appTabInstructions,
  {
    groupName: 'Program tab',
    tabId: 'programTab',
    defaultTabName: 'Program',
    hintText: 'Program, Agenda, etc.',
    children: [timelineDisplayChecks],
    radios: [{
      id: 'timeline',
      choices: [
        { id: 'default', label: 'Continuous Timeline' }, 
        { id: 'breakDays', label: 'View By Day'  }
      ]
    }],
  },{
    groupName: 'Performers tab',
    tabId: 'performersTab',
    defaultTabName: 'Performers',
    hintText: 'Performers, Speakers, etc.',
    topHint: 'Note: Performers only display when assigned to a session.',
    children: [performerProfileChecks]
  },{
    groupName: 'Sponsors tab',
    tabId: 'sponsorsTab',
    defaultTabName: 'Sponsors',
    hintText: 'Sponsors, Partners, etc.',
    children: [sponsorProfileChecks]
  },{
    groupName: 'Exhibitors tab',
    tabId: 'exhibitorsTab',
    defaultTabName: 'Exhibitors', // 
    hintText: 'Exhibitors, booths, etc.',
    topHint: 'Note: Exhibitors only display when assigned to a room/location.',
    children: [exhibitorProfileChecks]
  },
]